import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Mail, ArrowLeft, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : '/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Verifique o seu email para instruções de recuperação');
    } catch (error) {
      toast.error('Ocorreu um erro. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Gold accent */}
      <div className="hidden lg:flex lg:w-1/2 bg-[#B5985A] items-center justify-center p-12">
        <div className="text-center">
          <div className="mb-8">
            <img
              src="https://customer-assets.emergentagent.com/job_reviewfunnel/artifacts/wxdmy5mp_Opini%C3%A3o%20Contacto%20Directo%20%281%29.svg"
              alt="Opinião Contacto Directo"
              className="h-16 mx-auto filter brightness-0 invert"
            />
          </div>
          <h1 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat' }}>
            Recuperar Palavra-passe
          </h1>
          <p className="text-white/80 text-lg max-w-md">
            Introduza o seu email para receber instruções de recuperação.
          </p>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden text-center mb-8">
            <img
              src="https://customer-assets.emergentagent.com/job_reviewfunnel/artifacts/wxdmy5mp_Opini%C3%A3o%20Contacto%20Directo%20%281%29.svg"
              alt="Opinião Contacto Directo"
              className="h-12 mx-auto"
            />
          </div>

          {sent ? (
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Mail className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-[#212121] mb-4" style={{ fontFamily: 'Montserrat' }}>
                Email enviado!
              </h2>
              <p className="text-gray-500 mb-8">
                Se existir uma conta com o email <strong>{email}</strong>, receberá instruções para recuperar a sua palavra-passe.
              </p>
              <Link
                to="/admin/login"
                className="inline-flex items-center gap-2 text-[#B5985A] hover:text-[#A3884A] font-medium"
              >
                <ArrowLeft className="w-4 h-4" />
                Voltar ao login
              </Link>
            </div>
          ) : (
            <>
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-[#212121]" style={{ fontFamily: 'Montserrat' }}>
                  Esqueceu a palavra-passe?
                </h2>
                <p className="text-gray-500 mt-2">
                  Introduza o seu email e enviaremos instruções para recuperar a sua conta.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <Mail className="w-4 h-4 text-[#B5985A]" />
                    <span className="label-uppercase">Email</span>
                  </div>
                  <div className="relative">
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="email@exemplo.com"
                      className="h-12 border-2 border-gray-200 focus:border-[#B5985A] rounded-none"
                      required
                    />
                  </div>
                </div>

                <Button
                  type="submit"
                  disabled={loading}
                  className="w-full btn-gold h-12 flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <>
                      <Send className="w-5 h-5" />
                      Enviar instruções
                    </>
                  )}
                </Button>
              </form>

              <div className="mt-6 text-center">
                <Link
                  to="/admin/login"
                  className="inline-flex items-center gap-2 text-[#B5985A] hover:text-[#A3884A] font-medium"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Voltar ao login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
